import { Suspense } from 'react';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@predoc/cow';
import { DocumentViewerShell } from './DocumentViewerShell';
import { REGISTRY } from './registry';
import { documentRegistryKey, type DocumentKey } from './types';

interface PatientDocumentViewerProps {
  open: boolean;
  onClose: () => void;
  documentKey: DocumentKey;
}

export const PatientDocumentViewer = ({
  open,
  onClose,
  documentKey,
}: PatientDocumentViewerProps) => {
  const Viewer =
    REGISTRY[documentRegistryKey(documentKey.source, documentKey.type)];

  const handleOpenChange = (isOpen: boolean) => {
    if (!isOpen) onClose();
  };

  return (
    <Sheet open={open} onOpenChange={handleOpenChange}>
      <SheetContent
        fullScreen
        showCloseButton={false}
        className="flex flex-col gap-0 p-0"
      >
        <SheetHeader className="sr-only">
          <SheetTitle>Document viewer</SheetTitle>
        </SheetHeader>
        <Suspense
          fallback={<DocumentViewerShell onClose={onClose} isLoading />}
        >
          {Viewer ? (
            <Viewer documentKey={documentKey} onClose={onClose} />
          ) : null}
        </Suspense>
      </SheetContent>
    </Sheet>
  );
};
